/* tslint:disable */
/* eslint-disable */
/**
 * Venue Loyalty API
 * Onyx Gaming Venue Loyalty API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface GetPlayerActivityStatement200ResponseMonthlyActivityInner
 */
export interface GetPlayerActivityStatement200ResponseMonthlyActivityInner {
    /**
     * 
     * @type {string}
     * @memberof GetPlayerActivityStatement200ResponseMonthlyActivityInner
     */
    monthLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerActivityStatement200ResponseMonthlyActivityInner
     */
    monthDays?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerActivityStatement200ResponseMonthlyActivityInner
     */
    monthDuration?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerActivityStatement200ResponseMonthlyActivityInner
     */
    monthAmount?: string;
}


/**
 * Check if a given object implements the GetPlayerActivityStatement200ResponseMonthlyActivityInner interface.
 */
export function instanceOfGetPlayerActivityStatement200ResponseMonthlyActivityInner(value: object): boolean {
    let isInstance = true;
    return isInstance;
}

export function GetPlayerActivityStatement200ResponseMonthlyActivityInnerFromJSON(json: any): GetPlayerActivityStatement200ResponseMonthlyActivityInner {
    return GetPlayerActivityStatement200ResponseMonthlyActivityInnerFromJSONTyped(json, false);
}

export function GetPlayerActivityStatement200ResponseMonthlyActivityInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPlayerActivityStatement200ResponseMonthlyActivityInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'monthLabel': !exists(json, 'monthLabel') ? undefined : json['monthLabel'],
        'monthDays': !exists(json, 'monthDays') ? undefined : json['monthDays'],
        'monthDuration': !exists(json, 'monthDuration') ? undefined : json['monthDuration'],
        'monthAmount': !exists(json, 'monthAmount') ? undefined : json['monthAmount'],
    };
}

export function GetPlayerActivityStatement200ResponseMonthlyActivityInnerToJSON(value?: GetPlayerActivityStatement200ResponseMonthlyActivityInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'monthLabel': value.monthLabel,
        'monthDays': value.monthDays,
        'monthDuration': value.monthDuration,
        'monthAmount': value.monthAmount,
    };
}

